import { FaBell, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './NotificationDropdown.css';
import { slug as slugify } from "github-slugger";
import { useDispatch } from 'react-redux';
import { updatenotification } from '../../actions/NotificationActions';

const NotificationDropdown = ({
  notifications = [],
  unreadCount = 0,
  isOpen,
  toggle,
  onClose,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const handleNotificationClick = (e, notification) => {
    e.preventDefault(); // Prevent default behavior

    if (notification.type === 'test_created') {
      if (notification.title && notification.relatedEntity) {
        const slug = slugify(notification.title).substring(0, 60);
        navigate(`/test/${slug}/${notification.relatedEntity}`);
        if (!notification.isRead) {
          dispatch(updatenotification({ notificationId: notification._id }));
        }
        onClose();

      }
    }
  };

  return (
    <div className="notification-menu" >
      <button
        className="notification-toggle"
        onClick={toggle}
        aria-label="Notifications"
      >
        <div className="notification-icon-wrapper">
          <FaBell className="notification-icon" />
          {unreadCount > 0 && (
            <span className="notification-badge">{unreadCount}</span>
          )}
        </div>
      </button>

      {isOpen && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h5>Notifications</h5>
            <button
              className="close-button"
              onClick={onClose}
              aria-label="Close notifications"
            >
              <FaTimes size={16} />
            </button>
          </div>
          <div className="notification-list">
            {notifications.length > 0 ? (
              notifications.map(notification => (
                <div
                  key={notification._id}
                  className={`notification-item ${notification.isRead ? 'read' : 'unread'}`}
                  onClick={(e) => handleNotificationClick(e, notification)}
                  style={{ cursor: 'pointer' }}
                >
                  {!notification.isRead && <div className="unread-indicator"></div>}
                  <div className="notification-content">
                    <div className="notification-title">New Test: {notification.title}</div>
                    <div className="notification-message">{notification.message}</div>
                    <div className="notification-time">
                      {new Date(notification.createdAt).toLocaleString()}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="notification-empty">
                No notifications yet
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;